import { render, staticRenderFns } from "./ProtocolLine.vue?vue&type=template&id=20f5c525&scoped=true&"
import script from "./ProtocolLine.vue?vue&type=script&lang=js&"
export * from "./ProtocolLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f5c525",
  null
  
)

export default component.exports